import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { TARA_CHAT_API } from '../../constants/central-api';
import {
  setCurrentChatInfo,
  setLastUsedMCPs,
} from '../../../store/reducers/chatSlice';

export default async function get_tara_single_chat_api_call(
  conversationId: string
) {
  const accessToken = store.getState().auth.authorization.accessToken;
  const isWhiteLabel = store.getState().UI?.isWhiteLabel;
  const shop_slug = store.getState().user.company.shop_slug;
  let sellerToken: string;
  if (isWhiteLabel) {
    sellerToken = accessToken?.currentWhiteLabelSellerToken;
  } else {
    sellerToken = accessToken?.sellerToken;
  }

  const requestInfo: RequestInfo = {
    url: `${TARA_CHAT_API(shop_slug)}/${conversationId}`,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/json',
      Authorization: accessToken.type + ' ' + sellerToken,
    },
  };

  const actionType = 'GET_TARA_SINGLE_CHAT';
  const customMsg = 'Tara single chat data fetched successfully';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false
  );
  const response = res?.data;
  if (!response.success) {
    return false;
  }
  if (res.actionType === actionType && response.success === true) {
    if (response?.data === null) {
      return null;
    } else {
      if (
        response?.data?.conversation_info?.tokens?.total_tokens &&
        typeof response?.data?.conversation_info?.tokens?.total_tokens ===
          'number'
      ) {
        store.dispatch(
          setCurrentChatInfo({
            chatTokenCount:
              response?.data?.conversation_info?.tokens?.total_tokens ?? 0,
          })
        );
      } else {
        store.dispatch(
          setCurrentChatInfo({
            chatTokenCount: 0,
          })
        );
      }
      if (
        response?.data?.conversation_info?.last_used_mcps &&
        Array.isArray(response?.data?.conversation_info?.last_used_mcps)
      ) {
        store.dispatch(
          setLastUsedMCPs(response?.data?.conversation_info?.last_used_mcps)
        );
      }
      return response?.data;
    }
  }
}
